export enum CacheKeys {
  LOCALE = 'LOCALE_INFO',
  TOKEN_COOKIE = 'token',
  LOCALE_COOKIE = 'LANGUAGE',
  TOKEN = 'token',
  USER_COOKIE = 'user_code',
  TAGS_VIEW = 'TAGS_VIEW',
  WAREHOUSE_CODE = 'warehouse_code',
  PHYSICAL_WAREHOUSE_INFO = 'physical_warehouse_info',
  LABEL_PRINTER = 'LABEL_PRINTER_',
  PERMISSION_IDENTIFIER = 'permission_identifier_list',
  USER_PHYSICAL_WAREHOUSE_LIST = 'user_physical_warehouse_list',
  ALL_PHYSICAL_WAREHOUSE_LIST = 'all_physical_warehouse_list',
  ALL_WAREHOUSE_LIST = 'all_warehouse_list',
}
